import { IHoliday } from "../holidayTypes";

  export const NetherlandsHolidays: { [key: string]: IHoliday } = {
    // 2024
    "2024-01-01": { title: "Nieuwjaarsdag", type: "HOLIDAY" },
    "2024-03-29": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2024-03-31": { title: "Eerste Paasdag", type: "HOLIDAY" },
    "2024-04-01": { title: "Tweede Paasdag", type: "HOLIDAY" },
    "2024-04-27": { title: "Koningsdag", type: "HOLIDAY" },
    "2024-05-05": { title: "Bevrijdingsdag", type: "HOLIDAY" },
    "2024-05-09": { title: "Hemelvaartsdag", type: "HOLIDAY" },
    "2024-05-19": { title: "Eerste Pinksterdag", type: "HOLIDAY" },
    "2024-05-20": { title: "Tweede Pinksterdag", type: "HOLIDAY" },
    "2024-12-25": { title: "Eerste Kerstdag", type: "HOLIDAY" },
    "2024-12-26": { title: "Tweede Kerstdag", type: "HOLIDAY" },
    "2024-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" },

    // 2025
    "2025-01-01": { title: "Nieuwjaarsdag", type: "HOLIDAY" },
    "2025-02-14": { title: "Valentijnsdag", type: "SPECIAL_DAY" },
    "2025-04-18": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2025-04-20": { title: "Eerste Paasdag", type: "HOLIDAY" },
    "2025-04-21": { title: "Tweede Paasdag", type: "HOLIDAY" },
    "2025-04-26": { title: "Koningsdag", type: "HOLIDAY" },
    "2025-05-05": { title: "Bevrijdingsdag", type: "HOLIDAY" },
    "2025-05-29": { title: "Hemelvaartsdag", type: "HOLIDAY" },
    "2025-06-08": { title: "Eerste Pinksterdag", type: "HOLIDAY" },
    "2025-06-09": { title: "Tweede Pinksterdag", type: "HOLIDAY" },
    "2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2025-12-25": { title: "Eerste Kerstdag", type: "HOLIDAY" },
    "2025-12-26": { title: "Tweede Kerstdag", type: "HOLIDAY" },
    "2025-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" },

    // 2026
    "2026-01-01": { title: "Nieuwjaarsdag", type: "HOLIDAY" },
    "2026-02-14": { title: "Valentijnsdag", type: "SPECIAL_DAY" },
    "2026-04-03": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2026-04-05": { title: "Eerste Paasdag", type: "HOLIDAY" },
    "2026-04-06": { title: "Tweede Paasdag", type: "HOLIDAY" },
    "2026-04-27": { title: "Koningsdag", type: "HOLIDAY" },
    "2026-05-05": { title: "Bevrijdingsdag", type: "HOLIDAY" },
    "2026-05-14": { title: "Hemelvaartsdag", type: "HOLIDAY" },
    "2026-05-24": { title: "Eerste Pinksterdag", type: "HOLIDAY" },
    "2026-05-25": { title: "Tweede Pinksterdag", type: "HOLIDAY" },
    "2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2026-12-25": { title: "Eerste Kerstdag", type: "HOLIDAY" },
    "2026-12-26": { title: "Tweede Kerstdag", type: "HOLIDAY" },
    "2026-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" },

    // 2027
    "2027-01-01": { title: "Nieuwjaarsdag", type: "HOLIDAY" },
    "2027-02-14": { title: "Valentijnsdag", type: "SPECIAL_DAY" },
    "2027-03-26": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2027-03-28": { title: "Eerste Paasdag", type: "HOLIDAY" },
    "2027-03-29": { title: "Tweede Paasdag", type: "HOLIDAY" },
    "2027-04-27": { title: "Koningsdag", type: "HOLIDAY" },
    "2027-05-05": { title: "Bevrijdingsdag", type: "HOLIDAY" },
    "2027-05-06": { title: "Hemelvaartsdag", type: "HOLIDAY" },
    "2027-05-16": { title: "Eerste Pinksterdag", type: "HOLIDAY" },
    "2027-05-17": { title: "Tweede Pinksterdag", type: "HOLIDAY" },
    "2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2027-12-25": { title: "Eerste Kerstdag", type: "HOLIDAY" },
    "2027-12-26": { title: "Tweede Kerstdag", type: "HOLIDAY" },
    "2027-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" }
  };




// WEBPACK FOOTER //
// ./src/constants/holidays/europe/netherlandsHolidays.ts